import { Link } from "react-router-dom";
import { APP_NAME, APP_NAME_ML } from "@/lib/api";

const LINKS = [["/terms", "Terms of Service", "footer-terms"], ["/privacy", "Privacy Policy", "footer-privacy"], ["/refund", "Refund Policy (7-Day Rule)", "footer-refund"], ["/staff-rules", "Company Rules", "footer-rules"], ["/customer#support", "Support", "footer-support"]];

export const Footer = ({ ml = false }) => (
  <footer data-testid="global-footer" className="border-t border-[var(--line)] bg-white/70 mt-10">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-[var(--muted-text)]">
      {LINKS.map(([to, l, id]) => <Link key={to} to={to} data-testid={id} className="hover:text-[var(--accent-c)]">{l}</Link>)}
      <span className="ml-auto">18+ only · © {new Date().getFullYear()} {ml ? APP_NAME_ML : APP_NAME}</span>
    </div>
  </footer>
);
